<div class="access-denied col-12 common-background-color common-border-radius">
  <div class="access-denied__content">
    <img
      src="assets/images/temp/access-denied.svg"
      alt="Access denied"
      class="access-denied__icon"
    />

    <h1 class="access-denied__title" translate>title_access_denied</h1>

    <p class="access-denied__message" translate>label_access_denied_message</p>
    <p class="access-denied__message" translate>label_access_denied_contact</p>
    <p class="access-denied__message" translate>assistance.</p>
    <button
      id="access-denied-go-back-btn"
      pButton
      type="button"
      class="access-denied__button"
      (click)="goBack()"
    >
      <i class="pi pi-chevron-left access-denied__button-icon"></i>
      <span translate>label_go_back</span>
    </button>
  </div>
</div>
